/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { action } from '@ember/object';
import { type Registry as Services, service } from '@ember/service';
import { waitFor } from '@ember/test-waiters';
import { cached, tracked } from '@glimmer/tracking';
import {
  BillingQuoteCurrency,
  BillingQuotePeriod,
} from 'uplisting-frontend/models/billing-quote';
import UiModalComponent from 'uplisting-frontend/components/ui/modal';

export default class UiActivateAddOnModal extends UiModalComponent {
  @service('repositories/billing-quote')
  billingQuoteRepository!: Services['repositories/billing-quote'];
  @service session!: Services['session'];
  @service router!: Services['router'];
  @service intl!: Services['intl'];

  @tracked hasIncludedPropertiesWithoutCustomer = false;
  @tracked isLoading = false;

  @cached
  get body(): string | undefined {
    if (this.hasIncludedPropertiesWithoutCustomer) {
      return this.intl.t('paywall.modal.body.no_customer');
    }

    return super.body;
  }

  @cached
  get submitButtonText(): string | undefined {
    if (this.hasIncludedPropertiesWithoutCustomer) {
      return this.intl.t('paywall.modal.buttons.proceed');
    }

    return super.submitButtonText;
  }

  @action
  handleSubmit(): void {
    if (this.hasIncludedPropertiesWithoutCustomer) {
      this.router.transitionTo('account.billing');
      return;
    }

    super.handleSubmit();
  }

  @action
  @waitFor
  async setHasIncludedPropertiesWithoutCustomer(): Promise<void> {
    if (this.session?.currentUser?.customer) {
      this.hasIncludedPropertiesWithoutCustomer = false;
      return;
    }

    this.isLoading = true;
    const billingQuotes = await this.billingQuoteRepository.query({
      currency: BillingQuoteCurrency.USD,
      periods: [BillingQuotePeriod.monthly],
    });

    this.hasIncludedPropertiesWithoutCustomer =
      billingQuotes[0] && billingQuotes[0].numberOfPropertiesIncluded > 0;

    this.isLoading = false;
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Ui::Modal::ActivateAddOnModal': typeof UiActivateAddOnModal;
  }
}
